import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs font-bold tracking-[0.22em] uppercase ${
      light ? "text-sunny" : "text-terracotta"
    }`}
  >
    <span className={`h-px w-8 ${light ? "bg-sunny" : "bg-terracotta"}`} />
    {children}
  </span>
);
